<template>
  <vx-card
    class="mt-base"
    title="Content"
  >

    <h6 class="fs-1 mb-2">Content ID</h6>
    <quil
      :data="data.descriptionId"
      @change="data.descriptionId = $event.html"
    />

    <h6 class="fs-1 mb-2 mt-10">Content EN</h6>
    <quil
      :data="data.descriptionEn"
      @change="data.descriptionEn = $event.html"
    />

  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
.ls-content {
  font-size: 1.1rem;

  ul,
  ol {
    list-style-type: initial;
    padding-left: 20px;
  }
}
</style>
